import groupBy from 'lodash.groupby';

import { samplesApi } from '@/api';
import uniqBy from 'lodash.uniqby';
import { SAMPLE_ANALYSIS_STATUSES } from '@/config/constants';

/* eslint-disable no-param-reassign */

const searchGrouping = async (component) => {
  if (component.grouping.code) {
    try {
      const groupingSamples = await samplesApi.getSamplesFromGroupingId(
        component.grouping.code
      );
      if (groupingSamples.data.length > 0) {
        component.sampleIdsWithGrouping = {
          ...component.sampleIdsWithGrouping,
          [component.grouping.code]: groupingSamples.data,
        };
      } else {
        component.$notify({
          showClose: true,
          type: 'error',
          message: component.$t('analysesData.valuesTemperatureBulk.noSamples'),
        });
      }
    } catch (error) {
      component.$notify({
        showClose: true,
        type: 'error',
        message: error.response.data.error.message,
      });
    }
  }
  component.grouping.code = null;
};

const removeGrouping = (component, row) => {
  const { [row.groupingId]: removedGrouping, ...otherData } =
    component.sampleIdsWithGrouping;
  component.sampleIdsWithGrouping = { ...otherData };
};

const lotToOperationList = async (component) => {
  const groupingIds = Object.keys(component.sampleIdsWithGrouping);
  if (groupingIds.length) {
    try {
      const labSamplesId = [];
      groupingIds.forEach((id) => {
        component.sampleIdsWithGrouping[id].forEach((sample) => {
          labSamplesId.push(sample.labSampleId);
        });
      });
      const samplesAnalyses = await samplesApi.samplesAnalysesMultiple(
        labSamplesId,
        false
      );
      component.symLotData = samplesAnalyses.data
        .flatMap((item) => {
          const labSample = {
            labSampleId: item.sample.labSampleId,
            labSampleCode: item.sample.labSampleCode,
          };
          const values = item.analyses
            .filter(
              (analysis) =>
                analysis.labSampleAnalysisStatus !==
                SAMPLE_ANALYSIS_STATUSES.CANCELED
            )
            .flatMap((analysis) => {
              const analysisData = {
                labSampleAnalysisId: analysis.labSampleAnalysisId,
                analysisId: analysis.id,
                analysisCode: analysis.code,
                analysisDescription: analysis.description,
              };
              const operations = analysis.operationsWithValues.map((op) => ({
                ...labSample,
                ...analysisData,
                operationRegistryId: op.operationRegistryId,
                operation: op.operation,
                symbolType: op.value
                  ? op.value.symbolType ?? op.symbolType
                  : op.symbolType,
                symbol: op.value ? op.value.symbol ?? op.symbol : op.symbol,
                symbolLot: op.value ? op.value.symbolLot : null,
                operationValueId: op.value ? op.value.id : null,
              }));
              return operations;
            });
          return values;
        })
        .filter((op) => op.symbolType && op.symbolType !== '');
    } catch (error) {
      component.$notify({
        showClose: true,
        type: 'error',
        message: error.response.data.error.message,
      });
    }
  }
};

const getAnalysesValues = (component) => {
  if (component.symLotData.length) {
    try {
      component.analysesValues = uniqBy(component.symLotData, 'analysisId').map(
        (analysis) => ({
          analysisId: analysis.analysisId,
          analysisCode: analysis.analysisCode,
          analysisDescription: analysis.analysisDescription,
        })
      );
    } catch (error) {
      component.$notify({
        showClose: true,
        type: 'error',
        message: error.response.data.error.message,
      });
    }
  }
};

const getOperationsList = (component) => {
  if (component.analysesIds.length && component.symLotData.length) {
    try {
      const operations = component.symLotData.filter((op) =>
        component.analysesIds.includes(op.analysisId)
      );
      component.operationsFilteredByAnalyses = operations;
      const operationsList = groupBy(
        operations,
        (ov) => `${ov.symbolType}_${ov.symbol}_${ov.symbolLot}`
      );
      Object.keys(operationsList).forEach((key) => {
        const array = operationsList[key];
        const operationsGrouped = Object.values(
          groupBy(array, 'operationRegistryId')
        ).map((op) => ({
          analysisCode: op[0].analysisCode,
          analysisId: op[0].analysisId,
          analysisDescription: op[0].analysisDescription,
          operationRegistryId: op[0].operationRegistryId,
          operationDescription: op[0].operation,
          operations: op,
          symbolLot: op[0].symbolLot ?? null,
        }));
        operationsList[key] = {
          symbol: operationsList[key][0].symbol,
          symbolType: operationsList[key][0].symbolType,
          symbolLot: operationsList[key][0].symbolLot,
          operationValues: operationsGrouped,
        };
      });
      component.operationsList = operationsList;
    } catch (error) {
      component.$notify({
        showClose: true,
        type: 'error',
        message: error.response.data.error.message,
      });
    }
  }
};

const getSamplesList = (component) => {
  if (
    component.symLotData.length &&
    component.analysesValues.length &&
    Object.keys(component.operationsList).length
  ) {
    try {
      // Object.values(component.operationsList).forEach((aggregatedSymbol) => {
      //   aggregatedSymbol.operationValues.forEach((aggregatedOperation) => {
      //     aggregatedOperation.operations.forEach((operation) => {
      //       operation.symbolLot = aggregatedOperation.symbolLot;
      //     });
      //   });
      // });
      component.sampleList = groupBy(
        component.operationsFilteredByAnalyses,
        (s) => `${s.analysisId}_${s.operationRegistryId}`
      );
    } catch (error) {
      component.$notify({
        showClose: true,
        type: 'error',
        message: error.response.data.error.message,
      });
    }
  }
};

export default (component) => ({
  searchGrouping: () => searchGrouping(component),
  removeGrouping: (row) => removeGrouping(component, row),
  lotToOperationList: () => lotToOperationList(component),
  getAnalysesValues: () => getAnalysesValues(component),
  getOperationsList: () => getOperationsList(component),
  getSamplesList: () => getSamplesList(component),
});
